import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'terms-of-service',
    loadChildren: () => import('./views/terms-of-service/terms-of-service.module').then(m => m.TermsOfServiceModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./views/privacy/privacy.routes')
  },
  {
    path: 'pricing',
    loadComponent: () => import('./views/pricing/pricing.component').then(c => c.PricingComponent)
  },
  {
    path: 'contact',
    loadChildren: () => import('./views/faq/contact-us/contact-us.module').then(m => m.ContactUsModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./views/faq/faq.module').then(m => m.FaqModule)
  },
  {
    path: 'login',
    loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'signup',
    loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'documentation',
    loadChildren: () => import('./views/documentation/documentation.module').then(m => m.DocumentationModule)
  },
  {
    path: 'blog',
    loadChildren: () => import('./views/blog/blog.module').then(m => m.BlogModule)
  },
  {
    path: 'overview',
    loadChildren: () => import('./views/solutions/solutions.routes')
  },
  {
    path: 'compare',
    loadComponent: () => import('./views/compare/compare.component').then(c => c.CompareComponent)
  },
  
  {
    path: ':locale',
    children: [
      {
        path: '',
        loadChildren: () => import('./views/home/home.module').then(m => m.HomeModule)
      }, 
      {
        path: 'terms-of-service',
        loadChildren: () => import('./views/terms-of-service/terms-of-service.module').then(m => m.TermsOfServiceModule)
      },
      {
        path: 'privacy-policy',
        loadChildren: () => import('./views/privacy/privacy.routes')
      },
      {
        path: 'pricing',
        loadComponent: () => import('./views/pricing/pricing.component').then(c => c.PricingComponent)
      },
      {
        path: 'contact',
        loadChildren: () => import('./views/faq/contact-us/contact-us.module').then(m => m.ContactUsModule)
      },
      {
        path: 'faq',
        loadChildren: () => import('./views/faq/faq.module').then(m => m.FaqModule)
      },
      {
        path: 'login',
        loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'signup',
        loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'documentation',
        loadChildren: () => import('./views/documentation/documentation.module').then(m => m.DocumentationModule)
      },
      {
        path: 'blog',
        loadChildren: () => import('./views/blog/blog.module').then(m => m.BlogModule)
      },
      {
        path: 'overview',
        loadChildren: () => import('./views/solutions/solutions.routes')
      },
      {
        path: 'compare',
        loadComponent: () => import('./views/compare/compare.component').then(c => c.CompareComponent)
      }
    ]
  },

  {
    path: '**',
    redirectTo: ''
  },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'top'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
